import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { TimezoneProvider, TermsProvider, PORTAL_TERMS } from '@kioskgaming/ui';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <TimezoneProvider>
      <TermsProvider value={PORTAL_TERMS}>
        <App />
      </TermsProvider>
    </TimezoneProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
